import React, { useCallback } from "react";
import { connect } from "react-redux";
import FormField from '../../../../../dynamicFormBuilder/FormField';
import { UserDefinedCodesLayout, UserDefinedReferencesLayout } from '../Layout';
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';

function UserDefinedTab(props) {
    var currentUser = props.oidc?.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;

    const handleCodesFormLoad = useCallback(() => {
    }, []);

    const handleReferencesFormLoad = useCallback(() => {
    }, []);

    return (
        <TabPanel height={"auto"} defaultSelectedIndex={0}>
            <TabItem title="Codes">
                <FormField
                    currrentUser={currentUser}
                    layoutId='3F8B4E06-7C52-4D69-A0E1-9B2D6F1C8E74'
                    layoutName='WMExceptionUserDefinedCodesForm'
                    defaultFormSchema={UserDefinedCodesLayout}
                    formFields={props.formFields}
                    setformFields={props.setformFields}
                    handleFieldValueChange={props.handleFieldChange}
                    DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                    formRefs={props.formRefs}
                    onFormLoad={handleCodesFormLoad}
                />
            </TabItem>
            <TabItem title="References">
                <FormField
                    currrentUser={currentUser}
                    layoutId='3F8B4E06-7C52-4D69-A0E1-9B2D6F1C8E75'
                    layoutName='WMExceptionUserDefinedRefsForm'
                    defaultFormSchema={UserDefinedReferencesLayout}
                    formFields={props.formFields}
                    setformFields={props.setformFields}
                    handleFieldValueChange={props.handleFieldChange}
                    DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                    formRefs={props.formRefs}
                    onFormLoad={handleReferencesFormLoad}
                />
            </TabItem>
        </TabPanel>
    );
}

function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}

export default connect(mapStateToProps)(UserDefinedTab);
